import { type FC } from 'react';
import { ScrollArea, Stack } from '@mantine/core';
import { type PayoutTraderOrder } from '~/entities/payout';
import { Table } from '~/shared/ui/Table';
import { createTableData } from './utils';

interface OrdersListProps {
    items: PayoutTraderOrder[];
    isPollingEnabled?: boolean;
    onClick?: (order: PayoutTraderOrder) => void;
}

export const OrdersList: FC<OrdersListProps> = ({ onClick, items }) => {
    const tableData = createTableData({
        orders: items,
    });

    const handleRowClick = (item: PayoutTraderOrder) => {
        return onClick?.(item);
    };

    return (
        <Stack>
            <ScrollArea>
                <Table
                    striped
                    highlightOnHover
                    data={tableData}
                    onRowClick={handleRowClick}
                />
            </ScrollArea>
        </Stack>
    );
};
